import common from '../../common'

export const visitType = [
  { id: 1, label: 'Announced' },
  { id: 2, label: 'Unannounced' },
  { id: 3, label: 'Triggered' }
]
export const judgement = [
  { id: 1, label: 'Compliant' },
  { id: 2, label: 'Substantially Compliant' },
  { id: 3, label: 'Non Compliant - Moderate' },
  { id: 4, label: 'Non Compliant - Major' },
  { id: 5, label: 'Meets Standards' },
  { id: 6, label: 'Significant Risk Identified' },
  { id: 7, label: 'Requires Improvement' },
  { id: 8, label: 'This standard was met' },
  { id: 9, label: 'This standard was met in part' },
  { id: 10, label: 'This standard was not met' },
  { id: 11, label: 'Other' }
]

export const centreActionStatus = [
  { id: 1, label: 'Cancelled - SW Decision' },
  { id: 2, label: 'Cancelled - Centre Decision' },
  { id: 3, label: 'Cancelled - Centre & SW Decision' },
  { id: 4, label: 'Completed - Action Ongoing' },
  { id: 5, label: 'Completed - No Further Action' },
  { id: 6, label: 'In Progress - Behind Schedule' },
  { id: 7, label: 'In Progress - On Schedule' },
  { id: 8, label: 'Pending - Behind Schedule' },
  { id: 9, label: 'Pending - On Schedule' }
]

export const themeNoL1_1 = [
  { id: 1, label: 'Theme 1' },
  { id: 2, label: 'Theme 2' },
  { id: 3, label: 'Theme 3' },
  { id: 4, label: 'Theme 4' },
  { id: 5, label: 'Theme 5' },
  { id: 6, label: 'Theme 6' },
  { id: 7, label: 'Theme 7' },
  { id: 8, label: 'Theme 8' }
]

export const themeDescriptionL1_1 = [
  { id: 1, label: 'Child Centred Care and Support' },
  { id: 2, label: 'Effective Care and Support' },
  { id: 3, label: 'Safe Care and Support' },
  { id: 4, label: 'Health, Wellbeing and Development' },
  { id: 5, label: 'Leadership, Governance and Management' },
  { id: 6, label: 'Responsive Workforce' },
  { id: 7, label: 'Use of Resources' },
  { id: 8, label: 'Use of Information' }
]

export const themeNoL1_2 = [
  { id: 1, label: 'Standard 1' },
  { id: 2, label: 'Standard 2' },
  { id: 3, label: 'Standard 3' },
  { id: 4, label: 'Standard 4' },
  { id: 5, label: 'Standard 5' },
  { id: 6, label: 'Standard 6' },
  { id: 7, label: 'Standard 7' },
  { id: 8, label: 'Standard 8' },
  { id: 9, label: 'Standard 9' },
  { id: 10, label: 'Standard 10' }
]

export const themeDescriptionL1_2 = [
  { id: 1, label: 'Purpose & Function' },
  { id: 2, label: 'Management & Staffing' },
  { id: 3, label: 'Monitoring' },
  { id: 4, label: "Children's Rights" },
  { id: 5, label: 'Planning for Children & Young People' },
  { id: 6, label: 'Care of Young People' },
  { id: 7, label: 'Safeguarding & Child Protection' },
  { id: 8, label: 'Education' },
  { id: 9, label: 'Health' },
  { id: 10, label: 'Premises & Safety' }
]

export const themeNoL1_3 = [
  { id: 1, label: 'Theme 1' },
  { id: 2, label: 'Theme 2' },
  { id: 3, label: 'Theme 3' },
  { id: 4, label: 'Theme 4' },
  { id: 5, label: 'Theme 5' },
  { id: 6, label: 'Theme 6' },
  { id: 7, label: 'Theme 7' },
  { id: 8, label: 'Theme 8' }
]

export const themeDescriptionL1_3 = [
  { id: 1, label: 'Child Centred Services' },
  { id: 2, label: 'Effective Services' },
  { id: 3, label: 'Safe Services' },
  { id: 4, label: 'Health and Development' },
  { id: 5, label: 'Leadership, Governance & Management' },
  { id: 6, label: 'Use of Resources' },
  { id: 7, label: 'Responsive Workforce' },
  { id: 8, label: 'Use of Information' }
]

export const themeNoL2_1 = [
  { id: 1, label: 1.1 },
  { id: 2, label: 1.2 },
  { id: 3, label: 1.3 },
  { id: 4, label: 1.4 },
  { id: 5, label: 1.5 },
  { id: 6, label: 1.6 },
  { id: 7, label: 2.1 },
  { id: 8, label: 2.2 },
  { id: 9, label: 2.3 },
  { id: 10, label: 2.4 },
  { id: 11, label: 2.5 },
  { id: 12, label: 2.6 },
  { id: 13, label: 3.1 },
  { id: 14, label: 3.2 },
  { id: 15, label: 3.3 },
  { id: 16, label: 4.1 },
  { id: 17, label: 4.2 },
  { id: 18, label: 4.3 },
  { id: 19, label: 5.1 },
  { id: 20, label: 5.2 },
  { id: 21, label: 5.3 },
  { id: 22, label: 5.4 },
  { id: 23, label: 5.5 },
  { id: 24, label: 6.1 },
  { id: 25, label: 6.2 },
  { id: 26, label: 6.3 },
  { id: 27, label: 6.4 },
  { id: 28, label: 7.1 },
  { id: 29, label: 8.1 },
  { id: 30, label: 8.2 }
]

export const themeDescriptionL2_1 = [
  {
    id: 1,
    label:
      'Each child experiences care and support which respects their diversity and protects their rights.'
  },
  {
    id: 2,
    label: 'Each child’s dignity and privacy is respected and promoted.'
  },
  {
    id: 3,
    label:
      'Each child exercises choice and is enabled to participate in making informed decisions about their care.'
  },
  {
    id: 4,
    label:
      'Each child has access to information, provided in an accessible format, that takes account of their communication needs.'
  },
  {
    id: 5,
    label:
      'Each child develops and maintains positive attachments and links with family, the community, and other signiﬁcant people in their lives.'
  },
  {
    id: 6,
    label:
      'Each child is listened to and complaints are acted upon in a timely, supportive and effective manner.'
  },
  {
    id: 7,
    label:
      'Each child’s identiﬁed needs informs their placement in the residential centre.'
  },
  {
    id: 8,
    label:
      'Each child receives care and support based on their individual needs in order to maximise their personal development.'
  },
  {
    id: 9,
    label:
      'The residential centre is child-centred and homely, and the environment promotes the safety and wellbeing of each child.'
  },
  {
    id: 10,
    label:
      'The information necessary to support the provision of child-centred, safe and effective care is available for each child in the residential centre.'
  },
  {
    id: 11,
    label:
      'Children experience integrated care which is coordinated effectively within and between services.'
  },
  {
    id: 12,
    label:
      'Each child is supported in the transition from childhood to adulthood.'
  },
  {
    id: 13,
    label:
      'Each child is safeguarded from abuse and neglect and their care and welfare is protected and promoted.'
  },
  {
    id: 14,
    label:
      'Each child experiences care and support that promotes positive behaviour.'
  },
  {
    id: 15,
    label:
      'Incidents are effectively identiﬁed, managed and reviewed in a timely manner and outcomes inform future practice.'
  },
  {
    id: 16,
    label:
      'The health, wellbeing and development of each child is promoted, protected and improved.'
  },
  {
    id: 17,
    label:
      'Each child is supported to meet any identiﬁed health and development needs.'
  },
  {
    id: 18,
    label:
      'Each child is provided with educational and training opportunities to maximise their individual strengths and abilities.'
  },
  {
    id: 19,
    label:
      'The residential centre performs its functions as outlined in relevant legislation, regulations, national policies and standards to protect and promote the care and welfare of each child.'
  },
  {
    id: 20,
    label:
      'The residential centre has effective leadership, governance and management arrangements in place with clear lines of accountability to deliver child-centred, safe and effective care and support.'
  },
  {
    id: 21,
    label:
      'The residential centre has a publicly available statement of purpose that accurately and clearly describes the services provided.'
  },
  {
    id: 22,
    label:
      'Appropriate service-level agreements, contracts or other similar arrangements are in place with the funding body or bodies.'
  },
  {
    id: 23,
    label:
      'The residential centre strives to continually improve the safety and quality of the care and support provided.'
  },
  {
    id: 24,
    label:
      'The registered provider plans, organises and manages the workforce to deliver childcentred, safe and effective care and support.'
  },
  {
    id: 25,
    label:
      'The registered provider recruits people with the required competencies to manage and deliver child-centred, safe and effective care and support.'
  },
  {
    id: 26,
    label:
      'Residential centres support and supervise their workforce in delivering child-centred, safe and effective care and support.'
  },
  {
    id: 27,
    label:
      'Training and continuous professional development is provided to staff to deliver childcentred, safe and effective care and support.'
  },
  {
    id: 28,
    label:
      'Residential centres plan and manage the use of available resources to deliver child-centred, safe and effective care and support.'
  },
  {
    id: 29,
    label:
      'Information is used to plan, manage and deliver child-centred, safe and effective care and support.'
  },
  {
    id: 30,
    label:
      'Effective arrangements are in place for information governance and records management to deliver child-centred, safe and effective care and support.'
  }
]

export const themeNoL2_2 = [
  { id: 1, label: 1.1 },
  { id: 2, label: 2.1 },
  { id: 3, label: 2.2 },
  { id: 4, label: 2.3 },
  { id: 5, label: 2.4 },
  { id: 6, label: 2.5 },
  { id: 7, label: 2.6 },
  { id: 8, label: 2.7 },
  { id: 9, label: 3.1 },
  { id: 10, label: 4.1 },
  { id: 11, label: 4.2 },
  { id: 12, label: 4.3 },
  { id: 13, label: 5.1 },
  { id: 14, label: 5.2 },
  { id: 15, label: 5.3 },
  { id: 16, label: 5.4 },
  { id: 17, label: 5.5 },
  { id: 18, label: 5.6 },
  { id: 19, label: 5.7 },
  { id: 20, label: 5.8 },
  { id: 21, label: 5.9 },
  { id: 22, label: 5.1 },
  { id: 23, label: 5.11 },
  { id: 24, label: 6.1 },
  { id: 25, label: 6.2 },
  { id: 26, label: 6.3 },
  { id: 27, label: 6.4 },
  { id: 28, label: 6.5 },
  { id: 29, label: 6.6 },
  { id: 30, label: 7.1 },
  { id: 31, label: 8.1 },
  { id: 32, label: 9.1 },
  { id: 33, label: 10.1 },
  { id: 34, label: 10.2 },
  { id: 35, label: 10.3 },
  { id: 36, label: 10.4 }
]

export const themeDescriptionL2_2 = [
  { id: 1, label: 'Purpose & Function' },
  { id: 2, label: 'Management' },
  { id: 3, label: 'Register' },
  { id: 4, label: 'Notification of Significant Events' },
  { id: 5, label: 'Staffing' },
  { id: 6, label: 'Supervision & Support' },
  { id: 7, label: 'Training & Development' },
  { id: 8, label: 'Administrative Files' },
  { id: 9, label: 'Monitoring' },
  { id: 10, label: 'Consultation' },
  { id: 11, label: 'Complaints' },
  { id: 12, label: 'Access to Information' },
  { id: 13, label: 'Suitable Placement & Admissions' },
  { id: 14, label: 'Statutory Care Plans' },
  { id: 15, label: 'Statutory Care Plan Reviews' },
  { id: 16, label: 'Contact with Families' },
  { id: 17, label: 'Supervision & Visiting of Young People' },
  { id: 18, label: 'Social Work Role' },
  { id: 19, label: 'Emotional & Specialist Support' },
  { id: 20, label: 'Preparation for Leaving Care' },
  { id: 21, label: 'Discharges' },
  { id: 22, label: 'Aftercare' },
  { id: 23, label: "Children's Case & Care Records" },
  { id: 24, label: 'Individual Care in Group Living' },
  { id: 25, label: 'Provision of Food and Cooking Facilities' },
  { id: 26, label: 'Race, Culture, Religion, Gender and Disability' },
  { id: 27, label: 'Managing Behaviour' },
  { id: 28, label: 'Restraint' },
  { id: 29, label: 'Absence without Authority' },
  { id: 30, label: 'Safeguarding & Child Protection' },
  { id: 31, label: 'Education' },
  { id: 32, label: 'Health' },
  { id: 33, label: 'Accommodation' },
  { id: 34, label: 'Maintenance & Repairs' },
  { id: 35, label: 'Safety' },
  { id: 36, label: 'Fire Safety' }
]

export const themeNoL2_3 = [
  { id: 1, label: 1.1 },
  { id: 2, label: 1.2 },
  { id: 3, label: 1.3 },
  { id: 4, label: 1.4 },
  { id: 5, label: 1.5 },
  { id: 6, label: 1.6 },
  { id: 7, label: 1.7 },
  { id: 8, label: 2.1 },
  { id: 9, label: 2.2 },
  { id: 10, label: 2.3 },
  { id: 11, label: 2.4 },
  { id: 12, label: 2.5 },
  { id: 13, label: 3.1 },
  { id: 14, label: 3.2 },
  { id: 15, label: 3.3 },
  { id: 16, label: 3.4 },
  { id: 17, label: 4.1 },
  { id: 18, label: 4.2 },
  { id: 19, label: 4.3 },
  { id: 20, label: 5.1 },
  { id: 21, label: 5.2 },
  { id: 22, label: 5.3 },
  { id: 23, label: 5.4 },
  { id: 24, label: 6.1 },
  { id: 25, label: 7.1 },
  { id: 26, label: 7.2 },
  { id: 27, label: 7.3 },
  { id: 28, label: 7.4 },
  { id: 29, label: 8.1 },
  { id: 30, label: 8.2 }
]

export const themeDescriptionL2_3 = [
  {
    id: 1,
    label: 'The rights and diversity of each child are respected and promoted.'
  },
  { id: 2, label: 'The privacy and dignity of each child are respected.' },
  {
    id: 3,
    label:
      'Each child exercises choice and experiences effective care and support as part of a programme of special care.'
  },
  {
    id: 4,
    label:
      'Each child has access to information, provided in an accessible format that takes account of their communication needs.'
  },
  {
    id: 5,
    label:
      'Each child participates in decision-making, has access to an advocate, and consent is obtained in accordance with legislation and current best practice guidelines.'
  },
  {
    id: 6,
    label:
      'Each child develops and maintains positive attachments and links with family, the community and other significant people.'
  },
  {
    id: 7,
    label:
      'Each child’s complaints and concerns are listened to and acted upon in a timely, supportive and effective manner.'
  },
  {
    id: 8,
    label:
      'Each child is placed in special care, in accordance with his or her identified needs and subject to the relevant legal authority.'
  },
  {
    id: 9,
    label:
      'Each child has a programme of special care which details their needs and outlines the supports required to maximise their personal development.'
  },
  {
    id: 10,
    label:
      'The special care unit is homely and promotes the welfare, dignity and safety of each child, consistent with the provision of safety and security.'
  },
  {
    id: 11,
    label:
      'Children are actively supported in the transfer to and/or from special care and all transitions occur in a timely manner with a discharge plan in place to assure continuity of care.'
  },
  { id: 12, label: 'Special care units have a care record for each child.' },
  {
    id: 13,
    label:
      'Each child is safeguarded from abuse and neglect and their protection and welfare is promoted.'
  },
  {
    id: 14,
    label:
      'Each child experiences care that supports positive behaviour and emotional wellbeing.'
  },
  {
    id: 15,
    label:
      'Children are not subjected to any restrictive procedure unless there is evidence that it has been assessed as being required due to a serious risk to the safety and welfare of the child or that of others.'
  },
  {
    id: 16,
    label:
      'Incidents are managed and reviewed in a timely manner and outcomes inform practice at all levels.'
  },
  { id: 17, label: 'The health and development of each child is promoted.' },
  {
    id: 18,
    label:
      'Each child receives an assessment and is given appropriate support to meet any identified need.'
  },
  {
    id: 19,
    label:
      'Educational opportunities are provided to each child to maximise their individual strengths and abilities.'
  },
  {
    id: 20,
    label:
      'The special care unit performs its functions as outlined in relevant legislation, regulations, national policies and standards to protect each child and promote their welfare.'
  },
  {
    id: 21,
    label:
      'The special care unit has effective leadership, governance and management arrangements in place with clear lines of accountability.'
  },
  {
    id: 22,
    label:
      'The special care unit has a publicly available statement of purpose that accurately and clearly describes the services provided.'
  },
  {
    id: 23,
    label:
      'Appropriate service level agreements, contracts and or other similar arrangements are in place with the funding body or bodies.'
  },
  {
    id: 24,
    label:
      'The use of available resources is planned and managed to provide child-centred, effective and safe services to children.'
  },
  {
    id: 25,
    label:
      'Safe and effective recruitment practices are in place to recruit staff.'
  },
  {
    id: 26,
    label:
      'Staff have the required competencies to manage and deliver childcentred, effective and safe services to children.'
  },
  {
    id: 27,
    label:
      'Staff are supported and supervised to carry out their duties and promote and protect the care and welfare of children.'
  },
  {
    id: 28,
    label: 'Training is provided to staff to improve outcomes for children.'
  },
  {
    id: 29,
    label:
      'Information is used to plan and deliver a child-centred, safe and effective service.'
  },
  {
    id: 30,
    label:
      'Information governance arrangements ensure secure record-keeping and file-management systems are in place to deliver a child-centred, safe and effective service.'
  }
]

export const valueTable = {
  ...common.constants,
  visitType,
  themeNoL1_1,
  themeNoL1_2,
  themeNoL1_3,
  themeNoL2_1,
  themeNoL2_2,
  themeNoL2_3,
  themeDescriptionL1_1,
  themeDescriptionL1_2,
  themeDescriptionL1_3,
  themeDescriptionL2_1,
  themeDescriptionL2_2,
  themeDescriptionL2_3,
  judgement,
  centreActionStatus
}



// WEBPACK FOOTER //
// ./src/centre/configs/commonConfig.js